import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-common';

interface Account extends AccountInfo {
  idTokenClaims?: {
    roles?: string[]
  }
}

@Injectable({
    providedIn: 'root'
  })
export class TokenAdmService {

  constructor(private authService: MsalService) {}

  getRoles(): string[] {
    let account: Account = this.authService.instance.getAllAccounts()[0];
    return account.idTokenClaims?.roles;
  }

  hasRole(expectedRole: string): boolean {
      let account: Account = this.authService.instance.getAllAccounts()[0];
      //para ver el token
      //console.log(account.idTokenClaims);
      if (account !== undefined){
        if (!account.idTokenClaims?.roles == undefined) {
          return false;
        }
      return account.idTokenClaims?.roles?.includes(expectedRole);
    }
  }


   verificaUsuario(){
    let activeAccount = this.authService.instance.getAllAccounts()[0]
    if (activeAccount) {
      return true;
    }
    else {
      return false;
    }
  }

  hayCuentaActiva(){
    let activeAccount = this.authService.instance.getActiveAccount();
    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
     // alert(accounts[0].username)
      return true;
    }
    else {
   // alert('no')
      return false;}

  }
}
